import _ from "lodash";
import { axiosInstance } from "./globals";
import * as userService from "./userService";

import {DataSourceRequest} from "@/model/DataSourceRequest";
import {DataSourceResult} from "@/model/DataSourceResult";
import {CalGroupFilter, LocationFilter} from "@/model/filters";


export async function getCalendars(fromDate: string, toDate: string) {
  const headers = userService.getAuthHeaders();
  const params = { fromDate, toDate };

  return (await axiosInstance.get("/Calendars/List", { headers, params })).data;
}

export async function newCalendar(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Calendars/Create", data, { headers })).data;
}

export async function editCalendar(data) {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.post("/Calendars/Update", data, { headers })).data;
}

export async function deleteCalendar(id: number) {
  const headers = userService.getAuthHeaders();
  const params = { id };
  return (await axiosInstance.post("/Calendars/Delete", null, { headers, params })).data;
}

export async function getLocations(filter: LocationFilter) {
  const headers = userService.getAuthHeaders();
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize
  };

  if (filter.q) {
    body.filters = [
      { field: "name", operator: "contains", value: filter.q }
    ];
  }

  return (await axiosInstance.post("/Locations/List", body, { headers })).data;
}

export async function createNewLocation(name: string) {
  const headers = userService.getAuthHeaders();
  const body = { name };

  return (await axiosInstance.post("/Locations/Create", body, { headers })).data;
}

export async function editLocation(id: number, name: string) {
  const headers = userService.getAuthHeaders();
  const body = { id, name };

  return (await axiosInstance.post("/Locations/Update", body, { headers })).data;
}

export async function deleteLocation(id: number) {
  const headers = userService.getAuthHeaders();
  const params = { id };
  return (await axiosInstance.post("/Locations/Delete", null, { headers, params })).data;
}


export async function getAllGroups() {
  const headers = userService.getAuthHeaders();
  return (await axiosInstance.get("/CalGroups/ListAll", { headers })).data;
}
